import {
    columnKeyToParamColumn,
    columnsConfig,
} from '@/components/WellLoggingOperations/TabletSettings/ColumnSettings/config';
import { findActiveResearches, prepareCurveSettingsObj } from '../../profiles/libs/prepareProfileWellColumns';

/*
    Функция собирает из разных настроек планшета параметры, чтобы превратить
    это на выходе в поле params сущности template.

    Основные параметры: видимость колонки, размер колонки, параметр колонки (берется из словаря).
    Так же некоторые колонки имеют children. Это поле, если оно есть, обрабатывается для каждый колонки отдельно.
*/
export function prepareColumns(settings, additional) {
    const { columnsSizing, wellLoggingKeys, curveSettings, curveDisplaySettings, columnsVisibility } = settings;
    const { researches } = additional;

    const columnKeys = Object.keys(columnKeyToParamColumn);

    const columns = [];

    let totalWidth = 0;
    let idx = 0;

    for (const columnKey of columnKeys) {
        if (!columnsSizing[columnKey]) {
            continue;
        }

        const { width } = columnsSizing[columnKey];

        totalWidth += columnsVisibility[columnKey] ? width : 0;

        const column = {
            paramIndex: idx,
            paramNumber: columnKeyToParamColumn[columnKey],
            paramType: columnKeyToParamColumn[columnKey],
            paramColumn: columnKeyToParamColumn[columnKey],
            paramTitle: columnsConfig[columnKey],
            paramWidth: width,
            children: null,
        };

        if (columnKey === 'carrotage') {
            const carrotageChildren = findActiveResearches(
                wellLoggingKeys,
                researches,
                curveSettings,
                curveDisplaySettings
            );
            
            column.children = carrotageChildren.map((child) => {
                let strParamValue = child?.strParamValue;
                if (strParamValue.curveSettings || strParamValue.curveDisplaySettings || strParamValue.globalCurvesSettings){
                    strParamValue = prepareCurveSettingsObj(strParamValue);
                }
                return ({ paramNumber: child?.param, strParamValue });
            });
        }

        idx++;

        columns.push(column);
    }

    return { totalWidth, columns };
}

const prepareTemplateBody = (rootState, payload) => {
    const { wellId, wellKey, title, username, templateId, templateTitle } = payload;

    const settings = rootState.tabletSettings[wellKey];
    const researches = rootState.researches.data[wellId];
    const {
        columnsTooltipProps,
        displaySettings: { globalCurvesSettings },
    } = rootState;

    const { totalWidth, columns } = prepareColumns(settings, { researches });
    const { columnsOrder, columnsVisibility } = settings;

    const template = {
        id: templateId,
        templateTitle: title ?? templateTitle,
        username,
        templateWidth: totalWidth,
        params: columns,
        columnsOrders: JSON.stringify(columnsOrder),
        columnsVisibility: JSON.stringify(columnsVisibility),
        tooltipSettings: JSON.stringify(columnsTooltipProps),
        globalCurvesSettings: JSON.stringify(globalCurvesSettings),
    };

    console.log(template);
    
    return JSON.stringify(template);
};

const prepareTemplate = templateFromReq => {
    const newTemplate = { ...templateFromReq };
    const fieldKeys = [
        'columnsOrders',
        'columnsVisibility',
        'tooltipSettings',
        'globalCurvesSettings',
        'researchOrder',
    ];
    for (const key of fieldKeys) {
        try {
            if (templateFromReq[key]) {
                newTemplate[key === 'columnsOrders' ? 'columnsOrder' : key] =
                    templateFromReq[key] !== 'None' ? JSON.parse(templateFromReq[key]) : null;
            }
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            return null;
        }
    }

    return {
        ...newTemplate,
        params: newTemplate.params.filter(({ paramColumn, paramTitle }) => paramColumn && paramTitle),
    };
};

/*
    Поиск кривых в исследованиях скважины. Необходимый параметр для сущности template.
*/
// export const findActiveResearches = (wellLoggingKeys, researches) => {
//     const researchTypes = new Set();

//     if (researches) {
//         researches.forEach(r1 => {
//             r1.children.forEach(r2 => {
//                 r2.children.forEach(research => {
//                     if (wellLoggingKeys.includes(research.key)) {
//                         researchTypes.add(research.type);
//                     }
//                 });
//             });
//         });
//     }

//     return [...researchTypes].map(type => {
//         return {
//             strParamValue: type,
//         };
//     });
// };

export { prepareTemplateBody, prepareTemplate };
